<vpfa-mobile-page-title [title]="title" [tooltipContent]="tooltipContent">
    <ng-container right>
      <ng-content select="[right]"></ng-content>
    </ng-container>
</vpfa-mobile-page-title>